<template>
	<div class="about">

		<!-- <picker class=" pickerList" mode="multiSelector" 
			:range="selectAreaArr" :value="multiIndex"
			@change="areaChange" @columnchange="areaColumnchange">
			<div class="">{{selectedArea}}</div>
		</picker> -->
		
		 <div v-if="visible" :indicator-style="indicatorStyle" 
			:value="multiIndex"  class="picker-view flex_row padding0">
			<div class="item_box scrollbar bg_eee">
				<div @click="clickItem('sheng',item)" :class="'item '+(multiIndex[0]==index?'item_selected':'')" v-for="(item,index) in selectAreaArr[0]" :key="index">{{item}}</div>
			</div>
			<div class="item_box scrollbar bg_eee">
				<div @click="clickItem('shi',item)" :class="'item '+(multiIndex[1]==index?'item_selected':'')" v-for="(item,index) in selectAreaArr[1]" :key="index">{{item}}</div>
			</div>
			<div class="item_box scrollbar bg_eee">
				<div @click="clickItem('qu',item)" :class="'item '+(multiIndex[2]==index?'item_selected':'')" v-for="(item,index) in selectAreaArr[2]" :key="index">{{item}}</div>
			</div>
		</div>

		<div @click="confirm" class="center width300r radius40r bg_orange color5 padding5 automargin margint40r">
			确定</div>
	</div>
</template>

<script>
	
	// var selectedIndex=[0, 0, 0];//选中的序号
	export default {
		name: "selectarea",
		props: {
			mOpenMode: { type: String, default: "0" } //本页面打开模式，作为组件时由父页面传入，先于data数据
		},
		
		data() {
			return { 
				openMode:this.mOpenMode, //使用模式：0默认业务，1组件选项，2页面选项
				
				indicatorStyle:"",
				visible:true,
				areaList: [],
				selectAreaArr: [ [], [], [] ],
				multiIndex: [-1, -1, -1],
				selectedArea: '选择省市区',  
			}
		},
		created() { 
			console.log("onload end", this.$route.query);
			var option=this.$route.query || {};
			if(option && typeof option.openMode!='undefined'){ this.openMode=(option.openMode); }
			//this.startLoad();
		},
		mounted() {
			this.startLoad();
		},
		methods: {
			startLoad(){
				//if(this.openMode===0){ this.openMode=openMode; }else{return;}//未设时赋值
				//this.selectedIndexs = [];
				this.initArea();
			},
			confirm(){
				if( this.selectAreaArr[0][this.multiIndex[0]] && 
					this.selectAreaArr[1][this.multiIndex[1]] && 
					this.selectAreaArr[2][this.multiIndex[2]]
					){
					this.selectedArea =
						this.selectAreaArr[0][this.multiIndex[0]] + "," +
						this.selectAreaArr[1][this.multiIndex[1]] + "," +
						this.selectAreaArr[2][this.multiIndex[2]];
					console.log("确定",this.selectedArea);
					this.$emit("selectItemCallback",this.selectedArea);
				}else{
					alert("不完整");
				}
				
			},
			initArea(){
				var _this = this
				this.$axios.request({
						url: window.$config.url.getAreaList,
						data: {}
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							this.areaList = res.data;
							if(typeof this.areaList=="string")this.areaList=JSON.parse(this.areaList);
							//数据格式：[{"name":"河北","city": ["name":"石家庄","area": ["长安区","新乐市"]}]}];
							// 省
							for (let i = 0; i < _this.areaList.length; i++) {
								_this.selectAreaArr[0].push(_this.areaList[i].name)
							}
							// 市
							for (let i = 0; i < _this.areaList[0].city.length; i++) {
								// _this.selectAreaArr[1].push(_this.areaList[0].city[i].name)
							}
							// 区县
							for (let i = 0; i < _this.areaList[0].city[0].area.length; i++) {
								// _this.selectAreaArr[2].push(_this.areaList[0].city[0].area[i])
							}
				
						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert( "不成功" );
						}
					});
			},
			// 省市区确认事件
			areaChange: function(e) {
				var _this = this
				_this.multiIndex = e.detail.value
				// 数组内的下标
				console.log(JSON.stringify(_this.multiIndex))
				// 获取省市区总数据
				_this.selectedArea =
					_this.selectAreaArr[0][_this.multiIndex[0]] + "," +
					_this.selectAreaArr[1][_this.multiIndex[1]] + "," +
					_this.selectAreaArr[2][_this.multiIndex[2]];
				return _this.selectedArea;
			},
			// // 每列滑动的监听
			// areaColumnchange: function(e) {
			// 	//当滚动选择，value 改变时触发 change 事件，event.detail = {value: value}；value为数组，
			// 	//表示 picker-view 内的 picker-view-column 当前选择的是第几项（下标从 0 开始）
			// 	const val = e.detail.value;
			// 	console.log("--------"+val);
			// 	// this.year = this.years[val[0]]
			// 	// this.month = this.months[val[1]]
			// 	// this.day = this.days[val[2]]
				
			// 	var column=this.getChangeColumn(val);
			// 	var index=val[column];
				
			// 	var _this = this
			// 	// 第几列滑动
			// 	console.log("第几列滑动 = " + JSON.stringify(column))
			// 	// 第几列滑动选中的下标
			// 	console.log("第几列滑动选中的下标 = " + JSON.stringify(index))
			// 	// 第一列滑动
			// 	if (column === 0) {
			// 		_this.multiIndex[0] = index
			// 		// 第二列更新相应的数据
			// 		_this.selectAreaArr[1] = _this.areaList[_this.multiIndex[0]].city.map((item,
			// 			index) => {
			// 			return item.name
			// 		})
			// 		if (_this.areaList[_this.multiIndex[0]].city.length === 1) {
			// 			_this.selectAreaArr[2] = _this.areaList[_this.multiIndex[0]].city[0].area
			// 				.map((
			// 					item,
			// 					index) => {
			// 					return item
			// 				})
			// 		} else {
			// 			_this.selectAreaArr[2] = _this.areaList[_this.multiIndex[0]].city[_this
			// 				.multiIndex[
			// 					1]].area.map((item, index) => {
			// 				return item
			// 			})
			// 		}
			// 		// 第一列滑动  第二列 和第三列 都变为第一个
			// 		_this.multiIndex.splice(1, 1, 0)
			// 		_this.multiIndex.splice(2, 1, 0)
			// 	}
			// 	// 第二列滑动
			// 	if (column === 1) {
			// 		_this.multiIndex[1] = index
			// 		_this.selectAreaArr[2] = _this.areaList[_this.multiIndex[0]].city[_this
			// 			.multiIndex[
			// 				1]].area.map((item, index) => {
			// 			return item
			// 		})
			// 		// 第二列 滑动 第三列 变成第一个
			// 		_this.multiIndex.splice(2, 1, 0)
			// 	}
			// 	// 第三列滑动
			// 	if (column === 2) {
			// 		_this.multiIndex[2] = index
			// 	}
			// },
			// getChangeColumn(currVal){
			// 	console.log(selectedIndex);
			// 	var i=-1;
			// 	if(  selectedIndex[0]!=currVal[0])i= 0;
			// 	else if( selectedIndex[1]!=currVal[1])i= 1;
			// 	else if( selectedIndex[2]!=currVal[2])i= 2;
			// 	 selectedIndex=currVal;
			// 	return i;
			// },

			//-------------new
			clickItem(type,name){
				
				var _this = this
				if(type=='sheng'){
					_this.selectAreaArr[1]=[];_this.selectAreaArr[2]=[];
					_this.multiIndex[1]=-1;_this.multiIndex[2]=-1;
					console.log(type,name);
					for (let i = 0; i < _this.areaList.length; i++) {
						if(_this.areaList[i].name==name){
							_this.multiIndex[0]=i;
							for(let p = 0; p < _this.areaList[i].city.length; p++){
								_this.selectAreaArr[1].push(_this.areaList[i].city[p].name)
							}
						}
					}
				}
				if(type=='shi'){
					_this.selectAreaArr[2]=[];
					_this.multiIndex[2]=-1;
					for (let i = 0; i < _this.areaList[_this.multiIndex[0]].city.length; i++) {
						if(_this.areaList[_this.multiIndex[0]].city[i].name==name){
							_this.multiIndex[1]=i;
							for(let p = 0; p < _this.areaList[_this.multiIndex[0]].city[i].area.length; p++){
								_this.selectAreaArr[2].push( _this.areaList[_this.multiIndex[0]].city[i].area[p])
							}
						}
					}
				}
				if(type=='qu'){
					for (let i = 0; i < _this.areaList[_this.multiIndex[0]].city[_this.multiIndex[1]].area.length; i++) {
						if(_this.areaList[_this.multiIndex[0]].city[_this.multiIndex[1]].area[i]==name){
							_this.multiIndex[2]=i;
						}
					}
				}
				this.$forceUpdate();
			}
		}
	}
</script>

<style scoped>
	
	.picker-view {
		width: 100%;
		height: 300px;
		margin-top: 10px;

	}
	.item_box{
		display: inline;
		height: 300px;
		overflow-y: auto;
		/* width: 100px; */
		/* min-width: 100px; */
		flex: 1;
	}

	.item {
		padding: 12px 5px;
		text-align: center;
		/* white-space: nowrap; */
		/* margin:2px 0; */
		width: 100%;
		overflow: hidden;
	}
	.item_selected{color:#f00;}
	
</style>


// WEBPACK FOOTER //
// src/views/common/selectarea.vue